export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "talk-JitsiStreamBackgroundEffect.worker.worker.js?v=99a5b7909858d6320e4c");
}
